import type { Person } from '@/types/person';

/**
 * Whether the member is tagged at all, read from the person payload's own tag
 * names rather than the tag endpoint the card loads its colors from.
 *
 * The section around the card asks this, and keeps an untagged member's card
 * off the page. Keeping the question here rather than inside the card leaves
 * one answer: the card draws whatever the endpoint gives it.
 */
const hasTags = (person?: Person) => !!person?.tags.length;

export default hasTags;
